import {
    DYNAMIC_SECTION_SLUGS,
    STRUCTURED_SECTION_SLUGS,
} from '@src/components/product_pages/data';

const mapShowInMenuToBoolean = (value) => value === true || value === 'true';

const isStructuredOrDynamic = (slug) => (
    STRUCTURED_SECTION_SLUGS.includes(slug) || DYNAMIC_SECTION_SLUGS.includes(slug)
);

function mapGetOneProductPageData(responseData) {
    const content = responseData.content || {};
    const sections = (content.sections || []).map((section) => {
        const mapped = {
            ...section,
            data: section.data || {},
            showInMenu: mapShowInMenuToBoolean(section.showInMenu),
        };

        // Structured/dynamic sections use `data`, not free-form html arrays.
        if (isStructuredOrDynamic(section.slug)) {
            delete mapped.html;
        }

        return mapped;
    });

    return {
        ...responseData,
        content: {
            ...content,
            title: content.title || '',
            sections,
        },
    };
}

function mapGetListProductPagesData(responseData) {
    return (responseData || []).map((page) => ({
        ...page,
    }));
}

export {
    mapGetOneProductPageData,
    mapGetListProductPagesData,
};
